// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patientSidebar_sidebar__lRMUq {
  height: 100vh;
  overflow-y: auto;
  border-right: 1px solid var(--color-gray-border);
  background:
    linear-gradient(180deg, #ffffff 0%, #fff7fc 100%);
  color: var(--color-text-dark);
}

.pro-sidebar {
  background: transparent !important;
  border-right: 1px solid rgba(229, 231, 235, 0.95) !important;
  color: var(--color-text-dark) !important;
}

.pro-menu {
  padding: 6px 8px 16px !important;
}

.pro-menu-item {
  border-radius: 14px !important;
  margin: 4px 6px !important;
  transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease !important;
}

.pro-menu-item:hover {
  background: rgba(171, 0, 96, 0.08) !important;
}

.pro-menu-item.active,
.pro-menu-item.active:hover,
.pro-menu-item-pro-sidebar-active,
.pro-menu-item-active {
  background: rgba(171, 0, 96, 0.12) !important;
  box-shadow: 0 10px 24px rgba(171, 0, 96, 0.10) !important;
}

.pro-sub-menu,
.pro-menu .pro-sub-menu {
  background: transparent !important;
}

/* ------- Logo header ------- */
.patientSidebar_brand__V8yZ2,
.patientSidebar_brandSmall__BaOW3 {
  /* make the header clickable area */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;               /* taller than menu row for nice touch target */
  width: 100%;
  border: 0;
  background:
    radial-gradient(60px circle at 30% 20%, rgba(0,180,216,0.25), transparent 55%),
    radial-gradient(70px circle at 70% 15%, rgba(171,0,96,0.20), transparent 60%),
    rgba(255,255,255,0.7);
  border-bottom: 1px solid rgba(229, 231, 235, 0.95);
  cursor: pointer;
  padding: 8px 12px;
}

.patientSidebar_brandInner__Yg9FS {
  height: 32px;
  width: 120px;                /* width when expanded */
  display: flex;
  align-items: center;
  overflow: hidden;
  transition: width 200ms ease;
}

/* narrow the inner box when collapsed */
.patientSidebar_brandSmall__BaOW3 .patientSidebar_brandInner__Yg9FS {
  width: 32px;
}

.patientSidebar_brandImg__jAE5m {
  height: 100%;
  width: auto;                 /* preserve aspect ratio */
  display: block;
}

/* ------- Search input ------- */
.patientSidebar_searchInput__lmuUR {
  width: 90%;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid rgba(229, 231, 235, 0.95);
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 10px 24px rgba(0,0,0,0.04);
} 

.patientSidebar_searchInput__lmuUR:focus-visible {
  outline: 2px solid rgba(171, 0, 96, 0.25);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/patientSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gDAAgD;EAChD;qDACmD;EACnD,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,4DAA4D;EAC5D,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,+FAA+F;AACjG;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;;EAIE,6CAA6C;EAC7C,yDAAyD;AAC3D;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,gCAAgC;AAChC;;EAEE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,gBAAgB,+CAA+C;EAC3E,WAAW;EACX,SAAS;EACT;;;yBAGuB;EACvB,kDAAkD;EAClD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY,iBAAiB,wBAAwB;EACrD,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW,kBAAkB,0BAA0B;EACvD,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB","sourcesContent":[".sidebar {\n  height: 100vh;\n  overflow-y: auto;\n  border-right: 1px solid var(--color-gray-border);\n  background:\n    linear-gradient(180deg, #ffffff 0%, #fff7fc 100%);\n  color: var(--color-text-dark);\n}\n\n:global(.pro-sidebar) {\n  background: transparent !important;\n  border-right: 1px solid rgba(229, 231, 235, 0.95) !important;\n  color: var(--color-text-dark) !important;\n}\n\n:global(.pro-menu) {\n  padding: 6px 8px 16px !important;\n}\n\n:global(.pro-menu-item) {\n  border-radius: 14px !important;\n  margin: 4px 6px !important;\n  transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease !important;\n}\n\n:global(.pro-menu-item:hover) {\n  background: rgba(171, 0, 96, 0.08) !important;\n}\n\n:global(.pro-menu-item.active),\n:global(.pro-menu-item.active:hover),\n:global(.pro-menu-item-pro-sidebar-active),\n:global(.pro-menu-item-active) {\n  background: rgba(171, 0, 96, 0.12) !important;\n  box-shadow: 0 10px 24px rgba(171, 0, 96, 0.10) !important;\n}\n\n:global(.pro-sub-menu),\n:global(.pro-menu .pro-sub-menu) {\n  background: transparent !important;\n}\n\n/* ------- Logo header ------- */\n.brand,\n.brandSmall {\n  /* make the header clickable area */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 56px;               /* taller than menu row for nice touch target */\n  width: 100%;\n  border: 0;\n  background:\n    radial-gradient(60px circle at 30% 20%, rgba(0,180,216,0.25), transparent 55%),\n    radial-gradient(70px circle at 70% 15%, rgba(171,0,96,0.20), transparent 60%),\n    rgba(255,255,255,0.7);\n  border-bottom: 1px solid rgba(229, 231, 235, 0.95);\n  cursor: pointer;\n  padding: 8px 12px;\n}\n\n.brandInner {\n  height: 32px;\n  width: 120px;                /* width when expanded */\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  transition: width 200ms ease;\n}\n\n/* narrow the inner box when collapsed */\n.brandSmall .brandInner {\n  width: 32px;\n}\n\n.brandImg {\n  height: 100%;\n  width: auto;                 /* preserve aspect ratio */\n  display: block;\n}\n\n/* ------- Search input ------- */\n.searchInput {\n  width: 90%;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid rgba(229, 231, 235, 0.95);\n  background: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 10px 24px rgba(0,0,0,0.04);\n} \n\n.searchInput:focus-visible {\n  outline: 2px solid rgba(171, 0, 96, 0.25);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `patientSidebar_sidebar__lRMUq`,
	"brand": `patientSidebar_brand__V8yZ2`,
	"brandSmall": `patientSidebar_brandSmall__BaOW3`,
	"brandInner": `patientSidebar_brandInner__Yg9FS`,
	"brandImg": `patientSidebar_brandImg__jAE5m`,
	"searchInput": `patientSidebar_searchInput__lmuUR`
};
export default ___CSS_LOADER_EXPORT___;
